import { MultiSelect } from "@/core/components/ui/multi-select";
import type { PayrollTeam } from "@/payroll/roster/types";
import { validTeamIds } from "./utils";

export const TeamFilter = ({
  teams,
  value,
  onChange,
  disabled,
}: {
  teams: readonly PayrollTeam[];
  value: readonly string[];
  onChange: (ids: string[]) => void;
  disabled?: boolean;
}) => {
  const selectedIds = validTeamIds(value, teams);
  if (teams.length < 2 && selectedIds.length === 0) return null;
  return (
    <MultiSelect
      label="Teams"
      variant="filter"
      placeholder="All teams"
      options={teams}
      value={selectedIds}
      onChange={onChange}
      disabled={disabled}
    />
  );
};
